<template>
  <div :class="['input-group', { 'not-allowed' : disabled }]">
    <span :class="{required: isRequired && label, optional: isOptional}">{{ label }}</span>
    <div class="input-group__wrapper">
      <img
        v-if="originOrDestination"
        :src="originOrDestinationImg"
        alt="pin.png"
      >
      <input
        :id="id"
        :value="value"
        type="text"
        :name="name"
        :placeholder="placeholder"
        tabindex="0"
        :disabled="disabled"
        autocomplete="off"
        @input="(e) => onInput(e)"
        @click="onClick"
      >
    </div>
  </div>
</template>
<script>
import mixinMobile from '@/misc/mixinMobile';
import Origin from "@/assets/ics_f_location_pin.svg";
import Destination from "@/assets/ics_f_location_pin_check.svg";
import { isAndroid } from '@/helpers/getOs';

export default {
  mixins: [mixinMobile],
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isRequired: {
      type: Boolean,
    },
    label: {
      type: String,
      default: "",
    },
    isOptional: {
      type: Boolean,
    },
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    originOrDestination: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      Origin,
      Destination,
      typingTimer: null,
      doneTypingInterval: 1500,
    }
  },
  computed: {
    originOrDestinationImg() {
      return this.originOrDestination.toLowerCase() === 'origin' ? Origin : this.originOrDestination.toLowerCase() === 'destination' ? Destination : ''
    }
  },
  methods: {
    onInput(val) {
      let { value } = val.target
      this.$emit('input', value)
      if (this.isMobileSize && isAndroid()) {
        clearTimeout(this.typingTimer) // reset timer on every input
        this.typingTimer = setTimeout(() => {
          val.target.blur(); // remove focus
        }, this.doneTypingInterval);
      }
    },
    onClick(val) {
      this.$emit('click', val)
      if (this.isMobileSize && isAndroid()) {
        clearTimeout(this.typingTimer) // reset timer on every input
        this.typingTimer = setTimeout(() => {
          val.target.blur(); // remove focus
        }, this.doneTypingInterval);
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;

  span {
    font-size: 14px;
    line-height: 21px;
    color: $color-indigo-dark;
    font-weight: 600;

    @include for-size(mobile) {
      font-size: 12px;
    }

    &.required {
      &::after {
        content: "*";
        color: $color-red-5;
        margin-left: 4px;
      }
    }

    &.optional {
      &::after {
        content: "(Opsional)";
        color: $color-gray-shade;
        margin-left: 4px;
        font-weight: 400;
      }
    }
  }

  &__wrapper {
    display: flex;
    align-items: center;
    border-bottom: 1px solid $color-border-primary;

    img {
      margin-right: 8px;
      width: 20px !important;
      height: 20px !important;
      display: flex;
    }
  }

  input {
    width: 100%;
    border: none;
    padding: 0;
    height: 50px;
  }

  input:focus {
    outline: none;
  }

  input[type="text"]::placeholder {
    color: $color-gray-shade;
    font-size: 16px!important;
    text-transform: none !important;

    @include for-size(mobile) {
      font-size: 14px !important;
    }
  }
}

.not-allowed {
  cursor: not-allowed;

  input {
    background-color: transparent !important;
    opacity: 0.5;
  }
}
</style>
